import { CapoPlugin } from "/var/www/mj_client/releases/20251110070554/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];